// extracted by mini-css-extract-plugin
module.exports = {"image":"BlackFridayBanner-module__image___35q3V"};